export default {
  teamBoardList: [],
  teamBoardDetail: {},
  srchParam: {},
  replyList: [],
  errors: false,
  files: [],
};
